import { render, staticRenderFns } from "./AnswerCkeditor.vue?vue&type=template&id=0db7f0ee&scoped=true&"
import script from "./AnswerCkeditor.vue?vue&type=script&lang=js&"
export * from "./AnswerCkeditor.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCkeditor.vue?vue&type=style&index=0&id=0db7f0ee&prod&lang=less&"
import style1 from "./AnswerCkeditor.vue?vue&type=style&index=1&id=0db7f0ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7f0ee",
  null
  
)

export default component.exports